import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/cloud-upload.svg'


const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-12 mb-2",
  alt: "upload"
}, null, -1)
const _hoisted_3 = { class: "flex flex-row items-center" }
const _hoisted_4 = { class: "text-red-lp-100 font-semibold" }
const _hoisted_5 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalShowImage = _resolveComponent("ModalShowImage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            onDragover: _cache[3] || (_cache[3] = e => _ctx.setDragAndDrop(e, true)),
            onDragleave: _cache[4] || (_cache[4] = e => _ctx.setDragAndDrop(e, false)),
            onDrop: _cache[5] || (_cache[5] = e => _ctx.onSubmitDrag(e)),
            class: 
        `
      ${_ctx.isDragFile ? 'border-gray-lp-600 bg-gray-lp-100' : 'border-gray-lp-400'}
      items-center text-12px justify-between flex flex-row cursor-pointer border-2 border-dashed py-2 px-4 rounded my-2`
      
          }, [
            _createVNode("img", {
              src: _ctx.fileOriginal,
              onClick: _cache[1] || (_cache[1] = () => _ctx.onOpenShowImage(true)),
              class: "w-3/4 h-40 object-cover rounded mr-2 cursor-pointer",
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("div", null, [
              _createVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.file.click())),
                class: "text-10px xxl:text-12px rounded bg-red-lp-300 text-white font-semibold whitespace-no-wrap px-4 py-2 mr-2 focus:outline-none"
              }, _toDisplayString(_ctx.buttonCaption), 1)
            ]),
            _createVNode(_component_Icons, {
              name: "white-trash",
              color: "#B82025",
              onClick: _ctx.removeFile
            }, null, 8, ["onClick"])
          ], 34))
        : (_openBlock(), _createBlock("div", {
            key: 1,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$refs.file.click())),
            onDragover: _cache[7] || (_cache[7] = e => _ctx.setDragAndDrop(e, true)),
            onDragleave: _cache[8] || (_cache[8] = e => _ctx.setDragAndDrop(e, false)),
            onDrop: _cache[9] || (_cache[9] = e => _ctx.onSubmitDrag(e)),
            class: 
        `flex flex-col justify-center cursor-pointer items-center text-12px border-2 border-dashed rounded-lg my-2 py-10 ${
          _ctx.isDragFile
            ? 'border-gray-lp-600 bg-gray-lp-100'
            : _ctx.isDataValidate || _ctx.isDataValidate
            ? 'border-red-lp-1000'
            : 'border-gray-lp-400'
        }`
      
          }, [
            _hoisted_2,
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
            ]),
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.caption), 1)
          ], 34)),
      _createVNode("input", {
        type: "file",
        ref: "file",
        onChange: _cache[10] || (_cache[10] = e => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
        accept: "image/*",
        class: "hidden"
      }, null, 544),
      _withDirectives(_createVNode("p", { class: "text-12px text-red-lp-1000" }, " Pastikan kembali format file sesuai dan ukuran file tidak lebih dari " + _toDisplayString(_ctx.maxSize) + "MB ", 513), [
        [_vShow, _ctx.isDataValidate]
      ]),
      _withDirectives(_createVNode("p", { class: "text-12px text-gray-lp-600" }, _toDisplayString(_ctx.warningCaption), 513), [
        [_vShow, _ctx.isWarning]
      ])
    ]),
    _withDirectives(_createVNode(_component_ModalShowImage, {
      onClose: () => _ctx.onOpenShowImage(false),
      image: _ctx.fileOriginal
    }, null, 8, ["onClose", "image"]), [
      [_vShow, _ctx.isShow]
    ])
  ], 64))
}